import { Types } from '../actions/warehouseProductActions';

const initialState = {
  data: []
  ,loading: false
};

export const warehouseProductReducer = (state = initialState, action) => {

  switch (action.type) {
    case Types.GET_WAREHOUSE_PRODUCT_SUCCESS: { 
       return {
        ...state,
        loading: false,
        data: action.payload.data
      };
    }
    case Types.GET_WAREHOUSE_PRODUCT_REQUEST: {     
       return {
        ...state,
        loading: true,
      };
    }
    default:
      return state;
  }
};
